import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AdditionalContextInput } from "./TextContextInput";

interface AdditionalPlaybookParamsModalProps {
  open: boolean;
  onClose: () => void;
  onComplete: (additionalContext: string | undefined) => void;
}

export function AdditionalPlaybookParamsModal({
  open,
  onClose,
  onComplete,
}: AdditionalPlaybookParamsModalProps) {
  const [additionalContext, setAdditionalContext] = useState<string>();

  const handleComplete = () => {
    onComplete(additionalContext);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <Card className="border-0 shadow-none">
          <div className="p-6">
            <DialogTitle className="text-2xl font-semibold text-gray-900 mb-4">
              Additional Context (Optional)
            </DialogTitle>

            {/* Additional context */}
            <div className="space-y-2">
              {/* <h3 className="text-lg font-medium text-gray-900">
                Additional Context (Optional)
              </h3> */}
              <AdditionalContextInput
                additionalContext={additionalContext}
                setAdditionalContext={setAdditionalContext}
              />
            </div>

            {/* Footer */}
            <div className="flex justify-end items-center pt-6 border-t mt-6">
              <Button
                onClick={handleComplete}
                className="bg-gray-900 hover:bg-gray-800 text-white"
              >
                Continue
              </Button>
            </div>
          </div>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
